import { defineComponent as _defineComponent } from 'vue';
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, Teleport as _Teleport, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "fixed inset-y-0 left-0 z-50 shadow-xl lg:hidden",
    style: { "width": "340px" }
};
import ConversationSidebar from "./ConversationSidebar.vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'ConversationDrawer',
    props: {
        modelValue: { type: Boolean },
        conversations: {},
        activeConversationId: {},
        isLoading: { type: Boolean },
        services: {},
        itineraries: {}
    },
    emits: ["update:modelValue", "select", "new-conversation"],
    setup(__props) {
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
                _createVNode(_Transition, { name: "fade" }, {
                    default: _withCtx(() => [
                        (__props.modelValue)
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 0,
                                class: "fixed inset-0 z-40 bg-black/30 backdrop-blur-sm lg:hidden",
                                onClick: _cache[0] || (_cache[0] = ($event) => (_ctx.$emit('update:modelValue', false)))
                            }))
                            : _createCommentVNode("", true)
                    ]),
                    _: 1
                }),
                _createVNode(_Transition, { name: "slide-left" }, {
                    default: _withCtx(() => [
                        (__props.modelValue)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                                _createVNode(ConversationSidebar, {
                                    conversations: __props.conversations,
                                    "active-conversation-id": __props.activeConversationId,
                                    "is-loading": __props.isLoading,
                                    services: __props.services,
                                    itineraries: __props.itineraries,
                                    onSelect: _cache[1] || (_cache[1] =
                                        (c) => {
                                            _ctx.$emit('select', c);
                                            _ctx.$emit('update:modelValue', false);
                                        }),
                                    onNewConversation: _cache[2] || (_cache[2] = ($event) => (_ctx.$emit('new-conversation')))
                                }, null, 8, ["conversations", "active-conversation-id", "is-loading", "services", "itineraries"])
                            ]))
                            : _createCommentVNode("", true)
                    ]),
                    _: 1
                })
            ]));
        };
    }
});
